import { createAsyncThunk } from '@reduxjs/toolkit';

import loggerGenerator from '@travel/logger';

import { apiPath } from 'constants/api';

import type { ApiClient } from '@travel/api-client';
import type { ProviderFiltersResponse } from './types';
import { noticeError } from '@travel/tracker';

const logger = loggerGenerator();

export const fetchProviderFilters = createAsyncThunk<
  ProviderFiltersResponse,
  string,
  { extra: { apiClient: ApiClient } }
>('providerFilters/fetch', async (payload, { extra: { apiClient }, rejectWithValue }) => {
  try {
    const data = await apiClient.get(apiPath.providerFilters.pathname(payload));

    return data;
  } catch (error) {
    logger.error('Error fetching provider filters:', error);
    noticeError('Error fetching provider filters:', error);

    return rejectWithValue(error);
  }
});
